<template>
    <SearchTitle data-testid="remote-fallback-search-title">
        {{ resultCountTitle }}
    </SearchTitle>
</template>

<script setup lang="ts">
    import {computed, ref, watch} from 'vue';
    import {storeToRefs} from 'pinia';
    import {useLocale, useTranslation} from '#imports';
    import SearchTitle from './SearchTitle.vue';
    import {useCountryLabel} from './useCountryLabel';
    import {useProfilesStore} from '../../stores/profiles.store';
    import {useSearchUrlStore} from '../../stores/search-url.store';

    const {t} = useTranslation();
    const {countryCode} = useLocale();

    const {getCountryLabel} = useCountryLabel();
    const {remoteFallbackSearchResponse} = storeToRefs(useProfilesStore());
    const searchUrlStore = useSearchUrlStore();
    const {searchUrlParams} = storeToRefs(searchUrlStore);

    const MAX_NB_RESULTS = 300;

    const countryLabel = ref('');

    const resultCountTitle = computed(() =>
        t('search.header.icu.title.no.location', {
            cappedNbResults: Math.min(remoteFallbackSearchResponse.value?.pagination.totalElements ?? 0, MAX_NB_RESULTS),
            jobLabel: searchUrlParams.value.query,
            country: countryLabel.value,
        }),
    );

    watch(
        countryCode,
        async (newCountryCode) => {
            countryLabel.value = await getCountryLabel(newCountryCode);
        },
        {immediate: true},
    );
</script>
